import {useCallback, useSyncExternalStore} from 'react';

export type CookieConsent = 'accepted' | 'declined';

const STORAGE_KEY = 'cookie-consent';
const CHANGE_EVENT = 'cookie-consent-change';
const TTL = 365 * 24 * 60 * 60 * 1000;

/** до гидрации выбор неизвестен: баннер и счётчик ждут браузера, поэтому html страницы одинаков для всех и кешируется */
const PENDING = 'pending';
type Snapshot = CookieConsent | 'none' | typeof PENDING;

function read(): Snapshot {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return 'none';
		const {value, expires} = JSON.parse(raw);
		if ((value === 'accepted' || value === 'declined') && expires > Date.now()) return value;
	} catch {
		// хранилище может быть недоступно: тогда выбор просто не запоминается
	}
	return 'none';
}

function write(value: CookieConsent | null) {
	try {
		if (value) window.localStorage.setItem(STORAGE_KEY, JSON.stringify({value, expires: Date.now() + TTL}));
		else window.localStorage.removeItem(STORAGE_KEY);
	} catch {
		// см. read
	}
	window.dispatchEvent(new Event(CHANGE_EVENT));
}

const subscribe = (callback: () => void) => {
	window.addEventListener(CHANGE_EVENT, callback);
	window.addEventListener('storage', callback);
	return () => {
		window.removeEventListener(CHANGE_EVENT, callback);
		window.removeEventListener('storage', callback);
	};
};

/** Выбор посетителя по cookie: принято, отклонено, ещё не выбрано ('none') или неизвестно до гидрации ('pending') */
export function useCookieConsent() {
	const consent = useSyncExternalStore<Snapshot>(subscribe, read, () => PENDING);
	const accept = useCallback(() => write('accepted'), []);
	const decline = useCallback(() => write('declined'), []);
	const reset = useCallback(() => write(null), []);
	return {consent, accept, decline, reset};
}
